import { Link } from "react-router-dom";
import { FileText, Mail } from "lucide-react";

export default function Home() {
  return (
    <div className="bg-white">
      <section
        className="max-w-5xl mx-auto px-5 sm:px-8 pt-16 sm:pt-24 pb-24"
        data-testid="home-hero"
      >
        <div className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[var(--ldr-red)] mb-4">
            Plataforma oficial de atendimento
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight text-[var(--ldr-text)]">
            Reembolsos e apoio ao cliente{" "}
            <span className="text-[var(--ldr-red)]">Lendas do Rock</span>
          </h1>
          <p className="mt-6 text-base sm:text-lg text-[var(--ldr-text-muted)] leading-relaxed max-w-2xl">
            Submeta o seu pedido de reembolso ou contacte-nos.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link to="/reembolso" className="ldr-btn-primary" data-testid="home-cta-reembolso">
              <FileText size={16} />
              Pedir Reembolso
            </Link>
            <Link to="/contactos" className="ldr-btn-primary" data-testid="home-cta-contactar">
              <Mail size={16} />
              Contactar
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
